export default __webpack_public_path__ + "static/media/saturday night market.da858330.jpg";